document.addEventListener('alpine:init', () => {
  var { getElFromHtmlString } = Alpine.store('utilities');

  function resource(data = {}) {
    return {
      ...data,

      isLoading: false,

      page: +(new URLSearchParams(location.search).get('page') || '1'),

      init() {
        ['resourcepaginationlinkclickstart', 'facetsformsubmitstart'].forEach((eventName) => {
          document.addEventListener(eventName, () => this.isLoading = true);
        });

        ['resourcepaginationlinkclickend', 'facetsformsubmitend'].forEach((eventName) => {
          document.addEventListener(eventName, () => this.isLoading = false);
        });

        document.addEventListener('resourcepaginationlinkclicksuccess', (event) => {
          this.renderFromPaginationLinkClick(event.detail.url, event.detail.sectionHtml);
        });

        document.addEventListener('facetsformsubmitsuccess', (event) => {
          this.renderFromFacetsFormSubmit(event.detail.url, event.detail.sectionHtml);
        });
      },

      renderFromPaginationLinkClick(url, sectionHtml) {
        var urlPage = +(url.searchParams.get('page'));

        var newRootEl = this.$root.cloneNode(true);

        var newEls = {
          productListEl: newRootEl.querySelector('[data-ref-product-list]'),
          paginationPreviousEl: newRootEl.querySelector('[data-ref-pagination-previous]'),
          paginationNextEl: newRootEl.querySelector('[data-ref-pagination-next]')
        };

        var sectionEls = {
          productListEl: getElFromHtmlString(sectionHtml, '[data-ref-product-list]'),
          paginationPreviousEl: getElFromHtmlString(sectionHtml, '[data-ref-pagination-previous]'),
          paginationNextEl: getElFromHtmlString(sectionHtml, '[data-ref-pagination-next]')
        };

        if (urlPage >= this.page) {
          newEls.productListEl.insertAdjacentHTML('beforeend', sectionEls.productListEl.innerHTML);
          
          newEls.paginationNextEl.replaceWith(sectionEls.paginationNextEl);

          this.updateUrl(url);
        } else {
          newEls.productListEl.insertAdjacentHTML('afterbegin', sectionEls.productListEl.innerHTML);
          
          newEls.paginationPreviousEl.replaceWith(sectionEls.paginationPreviousEl);
        }
        
        Alpine.morph(this.$root, newRootEl.outerHTML);

        this.page = urlPage;
      },

      renderFromFacetsFormSubmit(url, sectionHtml) {
        this.updateUrl(url);

        Alpine.morph(this.$root, sectionHtml);

        this.page = 1;
      },

      updateUrl(url) {
        window.history.replaceState(null, null, url);
      }
    };
  };

  Alpine.data('resource', resource);
});
